import { Image } from '@vgn-medien-holding/vgn-fe-components';
import { DateTime, PropsWithClassProps } from '@vgn-medien-holding/vgn-react-components';
import { FallbackCard } from '@components/atoms/FallbackCard/FallbackCard';
import { Link } from '@components/atoms/Link/Link';
import { createDate } from '@utils/dateHelpers';
import { Article } from '@lib/graphql/generated';
import { Title } from '../../atoms/Title';

export interface TopStoriesProps extends PropsWithClassProps {
  articles: Article[];
  activeIndex: number;
}

export const TopStories = ({ articles, activeIndex, classProps }: TopStoriesProps) => {
  return (
    <div className={`h-full grid-rows-[auto,1fr] ${classProps?.root}`}>
      <div className="grid grid-cols-[auto,1fr] gap-6 pb-6">
        <h1 className="text-2xs font-bold uppercase tracking-extra-wide text-gray-600">Top Stories</h1>
        <div className="m-auto h-px w-full bg-gray-300"></div>
      </div>
      <div className="grid min-h-0 grid-rows-4 items-stretch gap-y-3">
        {articles.map((a, idx) => {
          return (
            <Link
              href={'/' + encodeURIComponent(a?.ressort?.slug) + '/' + encodeURIComponent(a?.slug)}
              key={idx}
              className={
                (activeIndex == idx ? 'border-primary ' : '') +
                'mx-auto grid w-full grid-cols-[2fr,3fr] overflow-hidden rounded-lg border bg-white drop-shadow-md xl:grid-cols-[1fr,4fr]'
              }
            >
              {a?.cover_image?.url ? (
                <Image
                  src={a.cover_image.url}
                  copyright={a.cover_image.copyright_text}
                  alt={a.headline}
                  fill
                  sizes="13vw"
                  className="rounded-lg object-cover"
                />
              ) : (
                <FallbackCard />
              )}
              <div className="grid grid-rows-[auto,1fr] px-8 py-2.5">
                <div className="text-sm font-bold tracking-widest text-gray-500">
                  {<DateTime date={createDate(a.created_at)} formatOptions={{ dateStyle: 'short' }} />}
                </div>
                <Title
                  level={2}
                  classProps={{
                    heading: 'self-center font-medium text-2xl lg:text-base line-clamp-3 xl:line-clamp-2',
                  }}
                >
                  {a.headline}
                </Title>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};
